// import RandingStyle1 from "../../randing/RandingStyle1";
import RandingStyle16 from "../../randing/RandingStyle16";

function Randing072({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle16
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      totalStep="2"
      articleOption={true}
      // img1Path={`${process.env.REACT_APP_CDN_BASE}/images/034/01_241220_01.jpg`}
      img2Path={`${process.env.REACT_APP_CDN_BASE}/images/072/25011301.jpg`}
      changedIMG={`${process.env.REACT_APP_CDN_BASE}/images/072/25011302.jpg`} // 스텝 변경되는 이미지
      qContainer1Path={`${process.env.REACT_APP_CDN_BASE}/images/034/01_241220_02.jpg`}
      qContainer2Path={`${process.env.REACT_APP_CDN_BASE}/images/034/02_241220_02.jpg`}
      qOptionImgPath={`${process.env.REACT_APP_CDN_BASE}/images/034/btns`}
      qOptions={["1~2개", "3개", "4개", "5개 이상"]}
      optionsArray="twobytwo"
      keepBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/orange/nextStepButton.png`}
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/orange/applyButton.png`}
      companyName="본원"
      privacyMessage="개인정보수집에 동의하시는 분만'신청하기'버튼을 눌러주세요."
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/ggul.jpg`}
      addStyle={{ bottom: "10%" }}
      propsBackgroundColor="#f4eeec"
    />
  );
}

export default Randing072;
